import { MovableDialog } from '@/components/shared/MovableDialog';
import { type ReactElement } from 'react';

/**
 * Gateway acknowledgement lookup. The action checks existing transport
 * evidence; an operator click cannot assert transmission or approval.
 */

export interface AgencyConfirmModalProps {
  readonly isOpen: boolean;
  readonly onYes: () => void;
  readonly onLater: () => void;
  readonly busy?: boolean;
}



export function AgencyConfirmModal({
  isOpen,
  onYes,
  onLater,
  busy = false,
}: AgencyConfirmModalProps): ReactElement | null {
  if (!isOpen) return null;
  // phase-movable-dialogs — shared movable shell.
  return (
    <MovableDialog
      persistKey="compiler.agencyConfirm"
      title="Check gateway acknowledgement"
      testId="agency-confirm-modal"
      width={480}
      zIndex={1000}
    >
      <>
        <p style={{ margin: 0, fontSize: 13 }}>
          Check the recorded gateway transmission for an acknowledgement.
          This does not create a transmission or a regulatory approval.
        </p>
        <div style={{ display: 'flex', gap: 8, justifyContent: 'flex-end' }}>
          <button
            type="button"
            data-testid="agency-confirm-later"
            onClick={onLater}
            disabled={busy}
            style={{
              padding: '6px 14px',
              border: '1px solid var(--border)',
              borderRadius: 4,
              background: 'var(--surface)',
              color: 'var(--text)',
              cursor: busy ? 'not-allowed' : 'pointer',
              fontSize: 13,
            }}
          >
            Later
          </button>
          <button
            type="button"
            data-testid="agency-confirm-yes"
            onClick={onYes}
            disabled={busy}
            style={{
              padding: '6px 14px',
              background: 'var(--accent, #4f46e5)',
              color: '#fff',
              border: 'none',
              borderRadius: 4,
              cursor: busy ? 'not-allowed' : 'pointer',
              fontSize: 13,
              fontWeight: 600,
              opacity: busy ? 0.6 : 1,
            }}
          >
            {busy ? 'Checking…' : 'Check acknowledgement'}
          </button>
        </div>
      </>
    </MovableDialog>
  );
}
